import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';

/**
 * Legal Markdown lives in the API (`resources/legal/*`) and is consumed by
 * four renderers (web, landing, Android, Apple), so it must stay pure
 * CommonMark — no raw HTML (the mobile renderers would show it literally).
 * Section anchors are therefore encoded as empty links `[](#id)` placed in
 * the heading line: every renderer displays them as nothing, and this
 * component turns them into real `id` targets so deep links like
 * `/legal/terms#refunds` (required by Paddle's refund-policy link) work.
 */
const components: Components = {
  a({ href, children, ...props }) {
    const isEmpty = Array.isArray(children)
      ? children.length === 0
      : children === undefined || children === null || children === '';
    if (href?.startsWith('#') && isEmpty) {
      return <span id={href.slice(1)} />;
    }
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  },
};

export function LegalMarkdown({ content }: { content: string }) {
  return <ReactMarkdown components={components}>{content}</ReactMarkdown>;
}
